import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const StickyNotesSolidAppIconIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1835 1920h-811l896-896v811q0 35-25 60t-60 25zm0-1792q35 0 60 25t25 60v811h-811q-35 0-60 25t-25 60v811H213q-35 0-60-25t-25-60V213q0-35 25-60t60-25h1622z" />
    </svg>
  ),
  displayName: 'StickyNotesSolidAppIconIcon',
});

export default StickyNotesSolidAppIconIcon;
